import {
  FOLLOW_UP_FILTER_VALUE,
  FOLLOW_UP_LABEL,
} from "encamp-shared/src/waste/discrepancyDisplayStatus";
import { DiscrepancyStatus } from "generated-graphql/graphql";

import { getDiscrepancyStatus, getStatusLabel } from "./DiscrepancyReviewDialog.helpers";

/**
 * Lifecycle states the manifest list's "Discrepancy Status" filter offers, in
 * the order a discrepancy moves through them. IGNORED is absent: dismissed rows
 * are non-discrepancies and draw no bubble, so selecting one would return
 * manifests whose Discrepancies column is blank. The backend
 * (`buildDiscrepancyStatusFilter`) drops it too, so a hand-typed
 * `discrepancyStatus:IGNORED` can't get around this.
 */
export const DISCREPANCY_STATUS_FILTER_VALUES: string[] = [
  DiscrepancyStatus.Unresolved,
  DiscrepancyStatus.Pending,
  DiscrepancyStatus.Resolved,
];

/**
 * What the filter offers for the reader. Staff also get the follow-up value,
 * which lists missing e-Manifest rows a customer never sees.
 */
export function discrepancyStatusFilterValues(isStaff: boolean): string[] {
  if (!isStaff) return DISCREPANCY_STATUS_FILTER_VALUES;
  const [unresolved, pending, ...rest] = DISCREPANCY_STATUS_FILTER_VALUES;
  return [unresolved, pending, FOLLOW_UP_FILTER_VALUE, ...rest].filter(
    (value): value is string => value !== undefined
  );
}

/** Filter option label, through the same map every status chip prints from. */
export function discrepancyStatusFilterLabel(value: string): string {
  if (value === FOLLOW_UP_FILTER_VALUE) return FOLLOW_UP_LABEL;
  return getStatusLabel(getDiscrepancyStatus({ status: value }));
}
